module.exports = __webpack_public_path__ + "img/Download - Green - Selected.3a0628b9.png";